import { useMutation, useQueryClient } from "@tanstack/react-query";
import { SCHOOL_LAB_POC } from "../../apiRoutes";
import axiosAuth from "../../../axiosAuth";

interface CreateSchoolPocRequest {
  schoolId: string;
    pocList: {
      pocName: string;
      pocDesignation: string;
      pocDepartment?: string;
      pocPhone: string;
      pocEmail: string;
    }[];
}

interface CreateSchoolPocResponse {
  success: boolean;
  message: string;
  data: {
    id: string;
    pocName: string;
    pocDesignation: string;
    pocDepartment?: string;
    pocPhone: string;
    pocEmail: string;
    schoolId: string;
  }[];
}

export const useCreateSchoolPocMutation = (options?: {
  onSuccess?: (data: CreateSchoolPocResponse) => void;
  onError?: (error: any) => void;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      request: CreateSchoolPocRequest
    ): Promise<CreateSchoolPocResponse> => {
      const response = await axiosAuth.post(
        SCHOOL_LAB_POC,
        request
      );
      return response.data;
    },
    onSuccess: (data) => {
      // Invalidate and refetch school POCs
      queryClient.invalidateQueries({ queryKey: ["schoolPocs"] });
      options?.onSuccess?.(data);
    },
    onError: (error) => {
      options?.onError?.(error);
    },
  });
};
